import { Record, type RecordOf } from 'immutable';

import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';

export type TaxLineItemProps = {
  id?: string;
  formId?: string;
  txfId?: string;
  name?: string;
  description?: string;
  displayOrder?: number;
};

export type TaxLineItem = RecordOf<TaxLineItemProps>;
export type TaxLineItemsStore = QcsSyncResourceStore<TaxLineItemProps>;

export const mkTaxLineItem = Record<TaxLineItemProps>({
  id: undefined,
  formId: undefined,
  txfId: undefined,
  name: undefined,
  description: undefined,
  displayOrder: undefined,
});

export const TAX_LINE_ITEMS_REDUCER_KEY = 'taxLineItemsStore' as const;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [TAX_LINE_ITEMS_REDUCER_KEY]: TaxLineItemsStore;
  }
}
